<template>
  <li
    :id="id"
    :class="classlist"
    tabindex="0">
    <a href="#" @click.prevent="activate()">{{ label }}</a>
  </li>
</template>

<script>
export default {
  name: 'PaginatorPageButton',
  props: {
    page: {
      type: Object,
      required: true
    },
    currentNumber: {
      type: Number,
      required: true
    }
  },
  computed: {
    id: function () {
      let id = `datatable_${this.page.type}`
      if (this.page.type === 'numeric') {
        id += '_' + this.page.number
      }
      return id
    },
    classlist: function () {
      const list = ['paginate_button', this.page.type]
      if (this.page.type === 'numeric' && this.page.number === this.currentNumber) {
        list.push('current')
      }
      if (this.page.number === undefined) {
        list.push('unavailable')
        list.push('disabled')
      }
      return list
    },
    label: function () {
      if (this.page.type === 'numeric') {
        return this.page.number + 1
      }
      return this.$t(`pagination.${this.page.type}`)
    }
  },
  methods: {
    activate: function () {
      if (this.page.number === undefined) {
        return
      }
      this.$emit('activated', this.page)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/paginator/PaginatorPageButton.vue